import { useEffect } from 'react';
export default function PreventScroll() {
    useEffect(function () {
        var style = document.body.style;
        var lastOverflow = style.overflow;
        style.overflow = 'hidden';
        return function () {
            style.overflow = lastOverflow;
        };
    }, []);
    return null;
}
